type DateInput = string | Date | null | undefined;

function toDate(input: DateInput): Date | null {
  if (input === null || input === undefined) return null;
  const d = input instanceof Date ? input : new Date(input);
  return Number.isFinite(d.getTime()) ? d : null;
}

export function formatDateShort(input: DateInput): string {
  const d = toDate(input);
  if (!d) return "";
  return d.toLocaleDateString("de-DE", {
    timeZone: "UTC",
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
}

export function formatDateLong(input: DateInput): string {
  const d = toDate(input);
  if (!d) return "";
  return d.toLocaleDateString("de-DE", {
    timeZone: "UTC",
    day: "numeric",
    month: "long",
    year: "numeric",
  });
}

export function formatMonthShort(input: DateInput): string {
  const d = toDate(input);
  if (!d) return "";
  return d.toLocaleDateString("de-DE", {
    timeZone: "UTC",
    month: "2-digit",
    year: "numeric",
  });
}
